export abstract class AbstractTemplate {
  public static getTemplate = (selector: string): Node => {
    const templateOverlay = document.querySelector(`${selector}`) as HTMLTemplateElement;
    const templateContent = templateOverlay.content as unknown as HTMLElement;

    return templateContent?.cloneNode(true);
  };
}
